import { render, staticRenderFns } from "./TypeFileJPGIcon.vue?vue&type=template&id=1414b775&"
import script from "./TypeFileJPGIcon.vue?vue&type=script&lang=js&"
export * from "./TypeFileJPGIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports